module.exports = __webpack_public_path__ + "static/web-toolbar-injection-79b7eb885a3afa75871e91894c55a54c.gif";